// extracted by mini-css-extract-plugin
export default {"item":"CrWNdDsN","buttons":"wldFInU7","mobile":"kchRpQvW","regButton":"iLb78In_"};